import type { ReactNode } from 'react';

import type { CheckboxMap, Facet } from '@/interfaces';
import { SelectedFilterItem } from '../selectedFilterItem/SelectedFilterItem';
import { scrollToElementById } from '@/utils/scroll';
import { focusElementById } from '@/utils/focus';

export interface SelectedCheckboxStateProps {
    id: string;
    facetList?: readonly Facet[];
    checkboxValues: CheckboxMap;
    displayValues?: Record<string, string>;
}

export interface SelectedCheckboxDispatchProps {
    checkBoxClick: (checkBoxValue: string | Record<string, unknown>) => void;
    triggerFetch: () => void;
}

export type SelectedCheckboxProps = SelectedCheckboxDispatchProps & SelectedCheckboxStateProps & { openFilters: () => void };

export const SelectedCheckboxFilter = ({
    id,
    facetList = [],
    checkboxValues,
    displayValues = {},
    checkBoxClick,
    triggerFetch,
    openFilters,
}: SelectedCheckboxProps) => {
    const removeFilter = (value: string): void => {
        checkBoxClick(value);
        triggerFetch();
    };
    const openFiltersAndScrollToId = () => {
        openFilters();
        scrollToElementById(id);
        focusElementById(id);
    };

    const createDisplayValue = (value: string): string | ReactNode =>
        facetList.find((facet) => facet.value === value)?.displayValue ?? displayValues[value] ?? value;

    return (
        <>
            {Object.keys(checkboxValues)
                .filter((value) => Boolean(checkboxValues[value]))
                .map((value) => (
                    <SelectedFilterItem
                        key={`unselect-${id}-${value}`}
                        value={createDisplayValue(value)}
                        removeFilter={() => removeFilter(value)}
                        openFilters={openFiltersAndScrollToId}
                    />
                ))}
        </>
    );
};
